/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IFindSearchCatalogItemsRequest,
  TFindSearchCatalogItemsModel,
  IMappers,
  TFindSearchCatalogItemsResponse_,
  TFindSearchCatalogItemsResponse,
  TFindSearchCatalogItemsResponse_1,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';

export function createFindSearchCatalogItemsModel(
  parameters: IFindSearchCatalogItemsRequest,
): TFindSearchCatalogItemsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'geo',
    pathApi: '/v1/find-search-catalog-items/',
    response: {
      200: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IFindSearchCatalogItemsOptions<TResponse200> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
  parameters: IFindSearchCatalogItemsRequest;
}

export async function fetchFindSearchCatalogItems<TResponse200>({
  httpApi,
  config,
  mappers,
  parameters,
}: IFindSearchCatalogItemsOptions<TResponse200>): Promise<TFindSearchCatalogItemsResponse | TResponse200> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createFindSearchCatalogItemsModel(parameters),
    config,
  )) as FetchResponse<TFindSearchCatalogItemsResponse_>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TFindSearchCatalogItemsResponse_1, headers);
    }
  }
  return {
    statusCode,
    response,
    headers: Array.from(headers),
  } as TFindSearchCatalogItemsResponse;
}
